// extracted by mini-css-extract-plugin
export default {"photoBigTitle":"maintenancePictureModal_photoBigTitle__pLVpR","photoItem":"maintenancePictureModal_photoItem__ur1at","photoItemTitle":"maintenancePictureModal_photoItemTitle__mv2hc","photoItemPhoto":"maintenancePictureModal_photoItemPhoto__PTS3P"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"photoBigTitle\":\"maintenancePictureModal_photoBigTitle__pLVpR\",\"photoItem\":\"maintenancePictureModal_photoItem__ur1at\",\"photoItemTitle\":\"maintenancePictureModal_photoItemTitle__mv2hc\",\"photoItemPhoto\":\"maintenancePictureModal_photoItemPhoto__PTS3P\"}";
        // 1793842504102
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  